import { render, staticRenderFns } from "./JsonContent.vue?vue&type=template&id=09334b7a&"
import script from "./JsonContent.vue?vue&type=script&lang=js&"
export * from "./JsonContent.vue?vue&type=script&lang=js&"
import style0 from "./JsonContent.vue?vue&type=style&index=0&id=09334b7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports